import styled from 'styled-components';

import { colors, breakpoints } from '@/styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  position: relative;

  width: 100%;
  margin-top: 5rem;
  padding: 20px;
  gap: 30px;

  border-top: 1px solid ${colors.gray4};

  @media (max-width: ${breakpoints.laptop}) {
    margin-top: 2rem;
  }

  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 1rem;
  }
`;

export const Icons = styled.div`
  display: flex;

  gap: 20px;

  @media (max-width: ${breakpoints.mobile}) {
    justify-content: space-around;

    width: 100%;
  }
`;

export const Icon = styled.div`
  color: ${colors.gray4};
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
    filter: brightness(90%);
  }
`;

export const Label = styled.div`
  position: absolute;
  top: -10px;

  padding: 0 10px;

  font-size: 1.1rem;
  background: ${colors.gray0};

  @media only screen and (max-width: ${breakpoints.mobile}) {
    top: -8px;

    font-size: 0.9rem;
  }
`;
